import { render, staticRenderFns } from "./LulusButton.vue?vue&type=template&id=4a7cd021&"
import script from "./LulusButton.vue?vue&type=script&lang=js&"
export * from "./LulusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports